<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-3">
      <label for="title" class="form-label">Title</label>
      <input type="text" class="form-control" id="title" v-model="localHomework.title" required>
    </div>
    <div class="mb-3">
      <label for="description" class="form-label">Description</label>
      <textarea class="form-control" id="description" rows="8" v-model="localHomework.description" required></textarea>
    </div>
    <div class="mb-3">
      <label for="release_date" class="form-label">Release Date</label>
      <input type="date" class="form-control" id="release_date" v-model="formattedReleaseDate" required>
    </div>
    <div class="mb-3">
      <label class="form-label">Homework Files</label>
      <input type="file" class="form-control mb-2" id="homework_files" multiple @change="handleFileChange('homework_files', $event)">
      <div v-if="homework_files.length">
        <ul class="list-group mt-2">
          <li v-for="file in homework_files" :key="file.name" class="list-group-item">{{ file.name }}</li>
        </ul>
      </div>
      <FileList 
        v-if="localHomework.file_paths && localHomework.file_paths.length > 0"
        title="Homework Files" 
        :files="localHomework.file_paths"
        :filesMetadata="localHomework.files_metadata"
        :onViewFile="showFileContent" 
        :onDownloadFile="downloadFile" 
        :onDeleteFile="file => deleteFile(file, 'file_paths')" 
      />
    </div>
    <button type="submit" class="btn btn-primary">{{ buttonText }}</button>
  </form>

  <StemErrorModal ref="stemErrorModal"/>
</template>
  
<script>
  import Homework from '@/models/homework';
  import HomeworkController from '@/controllers/HomeworkController';
  import FileList from '@/components/FilesList.vue';
  import StemErrorModal from './StemErrorModal.vue';

  export default {
    components: {
      FileList,
      StemErrorModal
    },
    props: {
      homework: {
        type: Object,
        required: true,
      },
      teachers: {
        type: Array,
        required: true,
      },
      semesters: {
        type: Array,
        required: true,
      },
      buttonText: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        localHomework: { ...this.homework },
        homework_files: [],
        filesToDelete: {
          file_paths: []
        }
      };
    },
    computed: {
      formattedReleaseDate: {
        get() {
          return Homework.formatDateForInput(this.localHomework.release_date);
        },
        set(newDate) {
          this.localHomework.release_date = newDate;
        },
      },
    },
    watch: {
      homework: {
        handler(newHomework) {
          this.localHomework = { ...newHomework };
        },
        deep: true,
      },
    },
    methods: {
      async handleSubmit() {
        this.$emit('submitForm', {
          ...this.localHomework,
          homework_files: this.homework_files,
          filesToDelete: this.filesToDelete
        });
      },
      getFileName(filePath) {
        return filePath.split('\\').pop();
      },
      async downloadFile(filePath) {
        try {
          const response = await HomeworkController.downloadFile(filePath);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.getFileName(filePath));
          document.body.appendChild(link);
          link.click();
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', 'Error downloading file');
        }
      },
      deleteFile(filePath, fileType) {
        this.filesToDelete[fileType].push(filePath);
        this.localHomework[fileType] = this.localHomework[fileType].filter(file => file !== filePath);
      },
      handleFileChange(type, event) {
        this[type] = event.target.files;
      },
      async showFileContent(filePath) {
        try {
          const response = await HomeworkController.downloadFile(filePath);
          // open file in new tab
          window.open(URL.createObjectURL(new Blob([response.data])));
        } catch (error) {
          this.$refs.stemErrorModal.show('Error', 'Error downloading file');
        }
      },
    },
  };
</script>